import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuth } from '../../../app/providers/useAuth';
import { createSubtask } from '../api/tasksApi';

// §8.1: инвалидирует ['tasks', userId] и ['tasks', userId, parentId, 'subtasks'].
export function useCreateSubtask(parentId: number) {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (title: string) => createSubtask(parentId, title),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['tasks', user?.id] });
      void queryClient.invalidateQueries({
        queryKey: ['tasks', user?.id, parentId, 'subtasks'],
      });
    },
  });
}
